import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import Table from "components/Table";
import Columns from "./Columns";
import FormikForm from "components/shared/FormikForm";
import { getEnergyTrxHistoryApi, getEnergyPackagesList } from "store/energyPackages/actions";
import EnergyPurchaseHistoryModal from "components/Modals/EnergyPurchaseHistory/EnergyPurchaseHistoryModel";

const List = () => {
  const dispatch = useDispatch();
  const [inputFieldsForSearch, setInputFieldsForSearch] = useState([
    {
      name: "search",
      type: "text",
      label: "",
      placeholder: "Search...",
    },
    {
      name: "energyPackageId",
      type: "dynamic_select",
      label: "",
      placeholder: "Select Package",
      options: []
    },
    {
      name: "paymentType",
      type: "select",
      label: "",
      placeholder: "Select Payment Type",
      options: [
        {
          value: "", label: "All"
        },
        {
          value: "bitanicaPay", label: "Bitanica Pay"
        },
        {
          value: "crypto", label: "Crypto"
        },
        {
          value: "fiat", label: "Fiat"
        }]
    },
    {
      name: "paymentStatus",
      type: "select",
      label: "",
      placeholder: "Select Status",
      options: [
        {
          value: "", label: "All"
        },
        {
          value: "success", label: "Success"
        },
        {
          value: "processing", label: "Processing"
        },
        {
          value: "failure", label: "Failure"
        },
        {
          value: "cancelled", label: "Cancelled"
        },

      ]
    }
  ]);
  const initialValuesForFilter = {
    search: "",
    energyPackageId: "",
    paymentType: "",
    paymentStatus: "success"
  };

  const { energyPurchaseHistory, loading, totalPurchaseCount, energyPackageList } = useSelector(({ EnergyPackage }) => ({
    loading: EnergyPackage?.loading,
    energyPurchaseHistory: EnergyPackage?.energyPurchaseHistory,
    totalPurchaseCount: EnergyPackage?.totalPurchaseCount,
    energyPackageList: EnergyPackage?.energyPackageList,
  }));

  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const [energyPurchaseHistoryModalShow, setEnergyPurchaseHistoryModalShow] = useState(false);
  const [id, setId] = useState(null);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 20,
    order: -1,
    orderBy: "date_created_utc",
    search: "",
    status: "",
    energyPackageId: "",
    paymentType: "",
    paymentStatus: "success"
  });

  useEffect(() => {
    const packageOptionsArray = [
      { value: "", label: "All" },
      ...energyPackageList.map(obj => ({
        value: obj._id,
        label: obj.name
      })),
      { value: "custom", label: "Custom" }
    ];

    setInputFieldsForSearch(prevFields =>
      prevFields.map(field =>
        field.name === "energyPackageId"
          ? { ...field, options: packageOptionsArray }
          : field
      )
    );
  }, [energyPackageList]);

  useEffect(() => {
    getApiData(filter);
    setcolumns(Columns({ handleViewHandler }))
  }, [filter]);


  async function getApiData() {
    try {
      dispatch(getEnergyTrxHistoryApi({ data: filter }));
      dispatch(getEnergyPackagesList({
        data: {
          page: 1,
          limit: 20,
          order: -1,
          orderBy: "date_created_utc",
        }
      }))
    }
    catch (error) { }
  }

  const handleViewHandler = (info) => {
    setEnergyPurchaseHistoryModalShow(true);
    setId(info?._id);
  };

  const handleFilterForm = (info) => {
    setFilter({
      ...filter,
      page: 1,
      limit: 20,
      order: -1,
      orderBy: "date_created_utc",
      search: info.search,
      status: info.status,
      energyPackageId: info.energyPackageId,
      paymentType: info.paymentType,
      paymentStatus: info.paymentStatus
    });
  };

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}

      {energyPurchaseHistoryModalShow &&
        <EnergyPurchaseHistoryModal
          show={energyPurchaseHistoryModalShow}
          handleClose={() => {
            setEnergyPurchaseHistoryModalShow(false);
            setId(null);
          }}
          title={"Energy Purchase History Details"}
          id={id}
        />
      }


      <section className="section">
        <div className="section-header">
          <h1>{"Energy Purchase History"}</h1>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-12">
                <div className="card-header">
                  <FormikForm
                    initialValues={initialValuesForFilter}
                    onSubmit={handleFilterForm}
                    loading={loading}
                    inputFields={inputFieldsForSearch}
                    buttonText={"Search"}
                  />
                </div>
              </div>
            </div>
          </div>

          {!loading && energyPurchaseHistory?.length > 0 && (
            <Table
              data={energyPurchaseHistory}
              columns={columns}
              total={totalPurchaseCount}
              filter={filter}
              setFilter={setFilter}
            />
          )}
          {!loading && totalPurchaseCount === 0 && (
            <p style={{ textAlign: "center" }}>No Energy Purchase Found</p>
          )}
        </div>
      </section>
    </>
  );
};

export default List;